import type { RaptorRaceState } from "./types.js";

export function raceRandom(seed: string): () => number {
  let state = 2166136261;
  for (const character of seed) { state ^= character.charCodeAt(0); state = Math.imul(state, 16777619); }
  return () => { state += 0x6d2b79f5; let value = state; value = Math.imul(value ^ (value >>> 15), value | 1); value ^= value + Math.imul(value ^ (value >>> 7), value | 61); return ((value ^ (value >>> 14)) >>> 0) / 4_294_967_296; };
}

export function raceFinishOrder(state: RaptorRaceState): string[] {
  if (state.race.finishOrder) return state.race.finishOrder;
  const ids = state.race.entrants.map(entrant => entrant.id);
  if (!state.race.motionSeed) return ids;
  const random = raceRandom(`${state.race.motionSeed}:finish`);
  for (let index = ids.length - 1; index > 0; index--) {
    const swap = Math.floor(random() * (index + 1));
    [ids[index], ids[swap]] = [ids[swap]!, ids[index]!];
  }
  return ids;
}

/** Deterministic presentation, never a new draw. All runners stay behind the line until the finish. */
export function raceRunnerProgress(progress: number, index: number, rank: number): number {
  const time = Math.max(0, Math.min(1, progress));
  const surge = Math.sin(time * Math.PI * 4 + index * 1.1) * Math.sin(time * Math.PI) * .017;
  const finishGap = rank * .009 * Math.pow(time, 5);
  return Math.max(0, Math.min(1 - rank * .009, time + surge - finishGap));
}
